export function findColumns(filter: string) {
  const date = { key: 'date', header: 'Dato', width: 10 }
  const price = { key: 'price', header: 'Pris', width: 15 }
  const time = { key: 'time', header: 'Klokkeslett', width: 10 }
  const station = { key: 'station', header: 'Stasjon', width: 20 }
  const operator = { key: 'operator', header: 'Operatør', width: 15 }
  const description = { key: 'description', header: 'Beskrivelse', width: 40 }

  switch (filter) {
    case 'fuel':
      return [date, time, description, station, price]
    case 'toll':
      return [date, time, station, operator, price]
    case 'workshop':
      return [date, time, description, price]
    case 'park':
      return [date, time, description, price]
    default:
      return []
  }
}
